
import { useEffect, useState } from "react"
import axios from "axios";

const useNewuo = (story) => {
  const [similarStories, setSimilarStories]= useState();
  const [showNewuo, setShowNewuo]= useState(false);
  let currentUrlSlug ="";
  let publicationID="";

  async function fetchNeuwo() {
    const publishedTimestamp = story["published-at"];
    const publishedDate = new Date(publishedTimestamp);
    const currentDate = new Date();
    const publishedBefore = (currentDate - publishedDate) / 1000 / 60;
    if(publishedBefore >= 15 && story["story-template"] !=="wau-juttu"){
      setShowNewuo(true);
      try {
        await axios.post("/newuo/getSimilarArticles", {
            id: story.id,
            publication_id:publicationID
        })
          .then(res => res.data.data&&setSimilarStories(res.data.data))
          .catch(err => console.log(err));
      } catch (error) {
        console.log(error.message)
      }
    }else{
      setShowNewuo(false);
    }

  }
  useEffect(()=>{
    if (typeof window === "undefined") {
      console.log("Oops, `window` is not defined")

    } else {
      const url = new URL(window.location.href);
      const urlSegments = url.pathname.split('/');
      const currentSlug = urlSegments[1];
      currentUrlSlug=currentSlug;
      switch (currentSlug) {
        case "vaasalehti":
          publicationID="vaasalehti";
          break;
        case "epari":
          publicationID="epari";
          break;
        default:
          publicationID="ilkka-pohjalainen";
      }

    }
    fetchNeuwo()
  },[])
  return [similarStories,showNewuo]
}
export default useNewuo
